import { styled } from "@mui/material/styles";

export const TwoFAComp = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    padding: "0 20px",
  },
  "& > p": {
    margin: "0 0 2rem 0",
    textAlign: "center",
    fontWeight: "normal",
    opacity: 0.8,
  },
  "& h1": {
    fontSize: "clamp(1rem, 1rem + 2vw, 1.875rem)",
    fontWeight: 600,
    margin: "2rem 0 1rem 0",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      margin: "1rem 0!important",
    },
  },
  "& .input-container": {
    display: "flex",
    gap: "5px",
    "& input": {
      flex: 1,
      minWidth: 0,
      padding: "2px 8px",
      background: "#211F45",
      boxShadow: "0 1px 2px 0 var(#0A0D12 · 5%, rgba(10, 13, 18, 0.05))",
      border: "transparent 2px solid",
      color: "#fff",
      fontFamily: "inherit",
      textAlign: "center",
      minHeight: "64px",
      fontWeight: 500,
      fontSize: "40px",
      lineHeight: "normal",
      borderRadius: "10px",
      // WebKit specific resets
      WebkitAppearance: "none",
      appearance: "none",
      WebkitTextSizeAdjust: "100%",
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale",
      "&:disabled": {
        opacity: ".5",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "20px",
        minHeight: "48px",
      },
      "&:focus, &:not(:placeholder-shown)": {
        outline: "none",
        borderColor: `${theme.palette.background.button_primary}`,
      },
      // Correct placeholder selector with double colons
      "&::placeholder": {
        fontSize: "40px",
        fontWeight: 500,
        lineHeight: "normal",
        opacity: 0.5,
        color: "#fff",
        [theme.breakpoints.down("sm")]: {
          fontSize: "20px",
        },
      },
      // WebKit specific placeholder
      "&::-webkit-input-placeholder": {
        fontSize: "40px",
        fontWeight: 500,
        lineHeight: "normal",
        opacity: 0.5,
        color: "#fff",
        [theme.breakpoints.down("sm")]: {
          fontSize: "20px",
        },
      },
      // Mozilla specific placeholder
      "&::-moz-placeholder": {
        fontSize: "40px",
        fontWeight: 500,
        lineHeight: "normal",
        opacity: 0.5,
        color: "#fff",
        [theme.breakpoints.down("sm")]: {
          fontSize: "20px",
        },
      },
    },
  },
  "& .resend": {
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "15px",
    gap: "10px",
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
    },
    "& p": {
      fontSize: "14px",
      margin: 0
    }
  },
  "& .resend-code": {
    textAlign: "center",
    color: "#D1C7FF",
    textDecoration: "none",
    border: 0,
    background: "transparent",
    cursor: "pointer",
    display: "flex",
    fontFamily: "inherit",
    fontSize: "14px",
    padding: 0
  },
  "& .helpers": {
    borderTop: "rgba(255,255,255,0.1) 1px solid",
    paddingTop: "20px",
    marginTop: "20px",
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    gap: "5px",
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
    },
    "& p": {
      fontSize: "12px",
      margin: 0,
    },
    "& button": {
      border: 0,
      background: "transparent",
      color: "#D1C7FF",
      fontFamily: "inherit",
      fontSize: "12px",
      margin: 0,
      cursor: "pointer",
    },
  },
}));
